import * as qs from 'qs';
import request from '../utils/request';

// 获取资源
export const getResource = () => request('/admin/settings/resource');

// 新建资源
export const createResource = (data) => request({
  url: '/admin/settings/resource',
  method: 'post',
  data,
});
// 修改资源
export const updateResource = (id, data) => request({
  url: `/admin/settings/resource/${id}`,
  method: 'put',
  data,
});
// 获取资源
export const getRole = () => request('/admin/settings/role');

// 新建资源
export const createRole = (data) => request({
  url: '/admin/settings/role',
  method: 'post',
  data,
});
// 修改资源
export const updateRole = (id, data) => request({
  url: `/admin/settings/role/${id}`,
  method: 'put',
  data,
});
